module.exports = __webpack_public_path__ + "static/img/point2.541a350.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/point2.png
// module id = 8PNz
// module chunks = 36